export const HAWAII_HOURS_NOTE =
  "Office hours are Monday–Friday, 8:30 AM–5:00 PM Pacific Time — roughly 5:30 AM–2:00 PM HST (spring/summer) or 6:30 AM–3:00 PM HST (fall/winter). Phone and video appointments are available island-wide.";

export const hawaiiRelatedPosts = [
  { slug: "life-insurance-agent-hawaii-all-cities", title: "Life Insurance Agent Hawaii — Complete City Directory" },
  { slug: "life-insurance-agent-near-me-hawaii-cities", title: "Life Insurance Agent Near Me — Every Hawaii City Served" },
  { slug: "life-insurance-quotes-near-me-hawaii-cities", title: "Life Insurance Quotes Near Me — Hilo, Kona, Honolulu & Lihue" },
  { slug: "life-insurance-agent-hawaii-guide", title: "Protecting Your Ohana — A Real Conversation About Life Insurance" },
  { slug: "life-insurance-agent-honolulu-hawaii", title: "Life Insurance Agent Honolulu Hawaii — Expert Coverage" }
];

export const hawaiiHubFAQs = [
  {
    question: "Who is a licensed life insurance agent near me in Hawaii?",
    answer: "Kenneth Carson is a licensed Comparion Insurance (Liberty Mutual affiliate) agent licensed in Hawaii, California, and Nevada. He serves families on Oahu, the Big Island, Maui, and Kauai — including Honolulu, Kapolei, Pearl City, Hilo, Kailua-Kona, Kahului, Wailuku, Kihei, and Lihue — through phone and video consultations. He holds a 5.0-star rating from 74 reviews. Call (916) 505-1000."
  },
  {
    question: "Can I buy life insurance in Hawaii from an agent who is not on my island?",
    answer: "Yes. What matters is that the agent holds an active Hawaii insurance license. Kenneth Carson is licensed in Hawaii and handles quotes, applications, and policy reviews by phone, video, and e-signature, so you get the same service whether you live in Honolulu, Hilo, Kona, or on Maui."
  },
  {
    question: "How much does life insurance cost in Hawaii?",
    answer: "Term life rates depend on age, health, tobacco use, coverage amount, and term length — not on which island you live on. Because Hawaii's cost of living and home prices are among the highest in the U.S., many local families need more coverage than the national average to pay off a mortgage and keep the household running. Kenneth can compare options and give you a free, no-obligation quote."
  },
  {
    question: "What type of life insurance is best for Hawaii families?",
    answer: "Most working families start with term life (10, 20, or 30 years) to cover the mortgage, kids' education, and income replacement. Multigenerational ohana households, small business owners, and people planning to pass down family land often add whole life or universal life for permanent coverage and estate planning."
  },
  {
    question: "Does Kenneth Carson work with military families in Hawaii?",
    answer: "Yes. Many Oahu families are connected to Joint Base Pearl Harbor-Hickam, Schofield Barracks, and Marine Corps Base Hawaii. Kenneth helps service members and spouses look at private coverage that supplements SGLI and continues after separation from service."
  }
];

export const hawaiiCities = [
  {
    slug: "honolulu",
    name: "Honolulu",
    area: "Oahu",
    zip: "96813",
    geo: { latitude: 21.3069, longitude: -157.8583 },
    image: "https://images.unsplash.com/photo-1507876466758-bc54f384809c?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=1600",
    metaTitle: "Life Insurance Agent Near Me Honolulu, HI | Kenneth Carson",
    metaDescription: "Looking for a life insurance agent near me in Honolulu, Hawaii? Kenneth Carson, licensed in HI, offers free term, whole & universal life quotes. 5.0★ (74 reviews).",
    headline: "Life Insurance Agent Near Me in Honolulu, Hawaii",
    intro: "Honolulu has some of the highest home prices and living costs in the country. That makes the right life insurance especially important — if something happens to you, your ohana needs enough to cover the mortgage, the bills, and the future you've been building. I'm Kenneth Carson, a Hawaii-licensed Comparion agent, and I help Honolulu families find coverage that actually fits.",
    neighborhoods: ["Kaimuki", "Manoa", "Kakaako", "Kalihi", "Moiliili", "Hawaii Kai", "Aiea", "Salt Lake", "Nuuanu", "Waikiki"],
    localNeeds: [
      { title: "High mortgage balances", text: "With median Oahu home prices near the top nationally, many families size term coverage to pay off the full mortgage." },
      { title: "Multigenerational households", text: "Kupuna living at home or kids heading to UH Manoa — coverage should protect everyone under one roof." },
      { title: "Military & federal workers", text: "Supplement SGLI or FEGLI with private coverage that stays with you after you leave service." }
    ],
    faqs: [
      {
        question: "Who is the best life insurance agent near me in Honolulu?",
        answer: "Kenneth Carson is a Hawaii-licensed Comparion Insurance agent with a 5.0-star rating from 74 reviews who serves Honolulu families from Hawaii Kai to Kalihi. He offers free phone and video consultations for term, whole, and universal life insurance. Call (916) 505-1000."
      },
      {
        question: "How much life insurance do I need living in Honolulu?",
        answer: "A common starting point is 10–12 times your annual income plus your remaining mortgage balance and expected college costs. Because Honolulu housing costs are so high, many families need more than the national average. Kenneth will walk through your numbers for free."
      },
      {
        question: "Can I meet with a Honolulu life insurance agent without visiting an office?",
        answer: "Yes. Kenneth handles everything by phone, video call, and e-signature, so busy Honolulu families can get quotes and apply without fighting H-1 traffic."
      },
      {
        question: "Do I need a medical exam for life insurance in Honolulu?",
        answer: "Not always. Depending on your age, health, and coverage amount, some policies offer accelerated underwriting with no medical exam. Kenneth can tell you which options you may qualify for."
      }
    ]
  },
  {
    slug: "hilo",
    name: "Hilo",
    area: "Hawaii Island (Big Island)",
    zip: "96720",
    geo: { latitude: 19.7071, longitude: -155.0885 },
    image: "https://images.pexels.com/photos/11258304/pexels-photo-11258304.jpeg?auto=compress&cs=tinysrgb&w=1600",
    metaTitle: "Life Insurance Agent Near Me Hilo, HI | Kenneth Carson",
    metaDescription: "Need a life insurance agent near me in Hilo, Hawaii? Kenneth Carson, licensed in HI, offers free life insurance quotes for East Hawaii families. 5.0★ (74 reviews).",
    headline: "Life Insurance Agent Near Me in Hilo, Hawaii",
    intro: "Hilo families are close-knit, practical, and plan for the long haul. Whether you're a teacher, a UH Hilo employee, a farmer in Puna, or you run a small business downtown, life insurance is how you make sure your family keeps their home and their roots if you're not there. I'm Kenneth Carson, and I'm licensed to help East Hawaii families get the right coverage.",
    neighborhoods: ["Downtown Hilo", "Keaukaha", "Kaumana", "Waiakea", "Puna", "Pahoa", "Keaau", "Volcano", "Honomu", "Papaikou"],
    localNeeds: [
      { title: "Protecting family land", text: "Permanent life insurance can help heirs keep land in the family instead of selling to cover costs." },
      { title: "Self-employed & farmers", text: "No employer group coverage? An individual term policy fills the gap at a predictable price." },
      { title: "Rural households", text: "Phone and video appointments mean no long drive — great for Puna and Hamakua families." }
    ],
    faqs: [
      {
        question: "Is there a life insurance agent near me in Hilo, HI?",
        answer: "Yes. Kenneth Carson is a Hawaii-licensed Comparion Insurance agent who serves Hilo, Keaau, Pahoa, Volcano, and all of East Hawaii through phone and video consultations. He has a 5.0-star rating from 74 reviews. Call (916) 505-1000."
      },
      {
        question: "What life insurance is best for Big Island families?",
        answer: "Working families usually start with affordable term life to cover the mortgage and income. Families with land or a family business often add whole life to help pass assets to the next generation without forcing a sale."
      },
      {
        question: "Can a Hilo farmer or small business owner get life insurance?",
        answer: "Absolutely. Self-employed and agricultural workers qualify for individual term and permanent policies. Kenneth can also discuss coverage that protects a business partner or key person."
      },
      {
        question: "How fast can I get covered in Hilo?",
        answer: "Many applicants can get a decision within days, and some policies use accelerated underwriting with no medical exam. Kenneth will tell you the fastest path based on your health and coverage needs."
      }
    ]
  },
  {
    slug: "kona",
    name: "Kailua-Kona",
    area: "Hawaii Island (Big Island)",
    zip: "96740",
    geo: { latitude: 19.6400, longitude: -155.9969 },
    image: "https://images.pexels.com/photos/13911575/pexels-photo-13911575.jpeg?auto=compress&cs=tinysrgb&w=1600",
    metaTitle: "Life Insurance Agent Near Me Kona, HI | Kenneth Carson",
    metaDescription: "Searching for a life insurance agent near me in Kona, Hawaii? Kenneth Carson, licensed in HI, offers free quotes for West Hawaii families. 5.0★ (74 reviews).",
    headline: "Life Insurance Agent Near Me in Kailua-Kona, Hawaii",
    intro: "From Kailua-Kona to Waikoloa and Captain Cook, West Hawaii runs on hospitality, tourism, coffee farms, and small businesses. Income can be seasonal, and that's exactly why a solid life insurance plan matters. I'm Kenneth Carson, a Hawaii-licensed Comparion agent, and I help Kona families protect what they've built.",
    neighborhoods: ["Kailua-Kona", "Holualoa", "Keauhou", "Kealakekua", "Captain Cook", "Waikoloa", "Kalaoa", "Kohala", "Waimea", "Honaunau"],
    localNeeds: [
      { title: "Hospitality & tourism workers", text: "Seasonal or tip-based income makes an affordable term policy a smart safety net." },
      { title: "Coffee farm & small business owners", text: "Protect your business, partners, and family land with the right mix of term and permanent coverage." },
      { title: "Retirees & second-home owners", text: "Final expense and permanent policies help cover costs and leave a legacy." }
    ],
    faqs: [
      {
        question: "Who is a life insurance agent near me in Kona, Hawaii?",
        answer: "Kenneth Carson is a Hawaii-licensed Comparion Insurance agent serving Kailua-Kona, Keauhou, Captain Cook, Waikoloa, and Waimea with free phone and video consultations. He holds a 5.0-star rating from 74 reviews. Call (916) 505-1000."
      },
      {
        question: "Can I get life insurance if my income is seasonal?",
        answer: "Yes. Insurers look at your overall annual income and finances. Kenneth helps tourism, hospitality, and self-employed Kona residents choose coverage with premiums that fit year-round."
      },
      {
        question: "Is life insurance more expensive on the Big Island?",
        answer: "No. Life insurance rates are driven by age, health, tobacco use, and coverage amount — not by which island you live on. Kona residents get the same rates available statewide."
      },
      {
        question: "Should a Kona coffee farmer consider whole life insurance?",
        answer: "It can make sense for farmers who want lifelong coverage, cash value, and a way to help heirs keep the farm. Kenneth will compare term and permanent options so you can decide."
      }
    ]
  },
  {
    slug: "maui",
    name: "Maui",
    area: "Maui",
    zip: "96732",
    geo: { latitude: 20.8893, longitude: -156.4729 },
    image: "https://images.pexels.com/photos/3948131/pexels-photo-3948131.jpeg?auto=compress&cs=tinysrgb&w=1600",
    metaTitle: "Life Insurance Agent Near Me Maui, HI | Kahului, Wailuku, Kihei",
    metaDescription: "Find a life insurance agent near me on Maui — Kahului, Wailuku, Kihei, Lahaina & Upcountry. Kenneth Carson, HI-licensed, free quotes. 5.0★ (74 reviews).",
    headline: "Life Insurance Agent Near Me on Maui, Hawaii",
    intro: "Maui families know better than anyone how quickly life can change. Planning ahead is how you make sure your loved ones can stay, rebuild, and keep going no matter what. I'm Kenneth Carson, a Hawaii-licensed Comparion agent, serving families in Kahului, Wailuku, Kihei, Lahaina, and Upcountry with honest, no-pressure life insurance advice.",
    neighborhoods: ["Kahului", "Wailuku", "Kihei", "Wailea", "Lahaina", "Kaanapali", "Makawao", "Pukalani", "Kula", "Paia", "Hana"],
    localNeeds: [
      { title: "Keeping families on-island", text: "Coverage that replaces income helps your family stay on Maui instead of being forced to move." },
      { title: "Rebuilding & mortgages", text: "Term life sized to your mortgage means your home is protected even if you're not here." },
      { title: "Tourism & service workers", text: "Many Maui jobs lack strong group life benefits — an individual policy fills the gap." }
    ],
    faqs: [
      {
        question: "Is there a life insurance agent near me on Maui?",
        answer: "Yes. Kenneth Carson is a Hawaii-licensed Comparion Insurance agent who serves Kahului, Wailuku, Kihei, Lahaina, Makawao, and all of Maui through phone and video consultations. He has a 5.0-star rating from 74 reviews. Call (916) 505-1000."
      },
      {
        question: "How much life insurance does a Maui family need?",
        answer: "Start with 10–12 times your income, then add your mortgage balance, debts, and future costs like college. Maui's high cost of living often means families need more coverage than they expect. Kenneth will run the numbers for free."
      },
      {
        question: "Does my employer's life insurance cover enough?",
        answer: "Usually not. Group coverage is often only 1–2 times your salary and may end if you change jobs. An individual policy stays with you no matter where you work."
      },
      {
        question: "Can I get life insurance quotes on Maui without meeting in person?",
        answer: "Yes. Kenneth provides quotes, applications, and policy reviews by phone, video, and e-signature — no travel required from Hana to Lahaina."
      }
    ]
  },
  {
    slug: "kapolei",
    name: "Kapolei",
    area: "Oahu",
    zip: "96707",
    geo: { latitude: 21.3354, longitude: -158.0580 },
    image: "https://images.pexels.com/photos/37134988/pexels-photo-37134988.jpeg?auto=compress&cs=tinysrgb&w=1600",
    metaTitle: "Life Insurance Agent Near Me Kapolei, HI | Ewa Beach & West Oahu",
    metaDescription: "Need a life insurance agent near me in Kapolei, Ewa Beach or West Oahu? Kenneth Carson, licensed in HI, offers free life insurance quotes. 5.0★ (74 reviews).",
    headline: "Life Insurance Agent Near Me in Kapolei, Hawaii",
    intro: "Kapolei and West Oahu are full of young families, new homeowners, and military households — people who are building something. Life insurance makes sure that the house, the kids' plans, and the future stay on track no matter what. I'm Kenneth Carson, a Hawaii-licensed Comparion agent, and I make getting covered simple.",
    neighborhoods: ["Kapolei", "Ewa Beach", "Ewa Gentry", "Ocean Pointe", "Makakilo", "Ko Olina", "Waipahu", "Mililani", "Pearl City", "Waianae"],
    localNeeds: [
      { title: "New homeowners", text: "Newer developments mean newer mortgages — term life locks in protection for the full loan." },
      { title: "Military families", text: "Close to JBPHH and Schofield, many families supplement SGLI with private coverage." },
      { title: "Young growing families", text: "Lock in low rates while you're young and healthy, and cover the years the kids depend on you." }
    ],
    faqs: [
      {
        question: "Who is a life insurance agent near me in Kapolei, HI?",
        answer: "Kenneth Carson is a Hawaii-licensed Comparion Insurance agent serving Kapolei, Ewa Beach, Makakilo, Waipahu, Mililani, and Pearl City with free phone and video consultations. He holds a 5.0-star rating from 74 reviews. Call (916) 505-1000."
      },
      {
        question: "Is SGLI enough life insurance for military families in Kapolei?",
        answer: "SGLI is a great start, but it ends after you leave the service unless converted, and it may not fully cover an Oahu mortgage. Many families add a private term policy that stays with them for life."
      },
      {
        question: "When should a young Kapolei family buy life insurance?",
        answer: "The best time is when you buy a home or have a child. Rates are lowest when you're young and healthy, and a 20- or 30-year term can lock in that price for decades."
      },
      {
        question: "How do I get a free life insurance quote in West Oahu?",
        answer: "Call Kenneth at (916) 505-1000, email Kenneth.Carson@Comparion.com, or fill out the quote form on this page. Consultations are free and there's no obligation."
      }
    ]
  },
  {
    slug: "pearl-city",
    name: "Pearl City",
    area: "Oahu",
    zip: "96782",
    geo: { latitude: 21.3972, longitude: -157.9752 },
    image: "https://images.pexels.com/photos/20608403/pexels-photo-20608403.jpeg?auto=compress&cs=tinysrgb&w=1600",
    metaTitle: "Life Insurance Agent Near Me Pearl City, HI | Aiea & Waipahu",
    metaDescription: "Looking for a life insurance agent near me in Pearl City, Aiea or Waipahu? Kenneth Carson, licensed in HI, offers free life insurance quotes. 5.0★ (74 reviews).",
    headline: "Life Insurance Agent Near Me in Pearl City, Hawaii",
    intro: "Pearl City sits at the heart of Oahu — close to Pearl Harbor, Leeward Community College, and some of the island's most established neighborhoods. Many families here have lived in the same home for generations, and many others are military households stationed nearby. I'm Kenneth Carson, a Hawaii-licensed Comparion agent, and I help Pearl City families put a plan in place that protects the people they love.",
    neighborhoods: ["Pearl City", "Pacific Palisades", "Waimalu", "Momilani", "Pearlridge", "Aiea", "Halawa", "Waipahu", "Waipio", "Waiau"],
    localNeeds: [
      { title: "Military & DoD civilians", text: "Near Joint Base Pearl Harbor-Hickam — private term coverage supplements SGLI/FEGLI and stays with you." },
      { title: "Long-time family homes", text: "Permanent coverage can help the next generation keep the family home instead of selling it." },
      { title: "Kupuna & final expenses", text: "Smaller whole life or final expense policies take the cost burden off your children." }
    ],
    faqs: [
      {
        question: "Who is a life insurance agent near me in Pearl City, HI?",
        answer: "Kenneth Carson is a Hawaii-licensed Comparion Insurance agent serving Pearl City, Aiea, Waimalu, Pacific Palisades, and Waipahu with free phone and video consultations. He holds a 5.0-star rating from 74 reviews. Call (916) 505-1000."
      },
      {
        question: "Do military families at Pearl Harbor need extra life insurance?",
        answer: "Often, yes. SGLI provides up to $500,000 while you serve, but it ends after separation unless converted, and Oahu housing costs are high. Many families add a private term policy that follows them for life."
      },
      {
        question: "Can I get life insurance for my parents in Pearl City?",
        answer: "With their consent and participation, yes. Adult children often help parents buy final expense or small whole life policies so funeral and end-of-life costs don't fall on the family."
      },
      {
        question: "How do I get a free life insurance quote in Pearl City?",
        answer: "Call Kenneth at (916) 505-1000, email Kenneth.Carson@Comparion.com, or fill out the quote form on this page. There's no cost and no obligation."
      }
    ]
  },
  {
    slug: "kailua-kaneohe",
    name: "Kailua & Kaneohe",
    area: "Windward Oahu",
    zip: "96734",
    geo: { latitude: 21.4022, longitude: -157.7394 },
    image: "https://images.pexels.com/photos/4394630/pexels-photo-4394630.jpeg?auto=compress&cs=tinysrgb&w=1600",
    metaTitle: "Life Insurance Agent Near Me Kailua & Kaneohe, HI | Windward Oahu",
    metaDescription: "Need a life insurance agent near me in Kailua or Kaneohe? Kenneth Carson, HI-licensed, serves Windward Oahu families with free life insurance quotes. 5.0★ (74 reviews).",
    headline: "Life Insurance Agent Near Me in Kailua & Kaneohe, Hawaii",
    intro: "Windward Oahu families love the slower pace — beach mornings in Kailua, the bay in Kaneohe, and neighbors who look out for each other. But Windward home values are some of the highest on the island, and that means your family needs real protection if something happens to you. I'm Kenneth Carson, a Hawaii-licensed Comparion agent, serving Kailua, Kaneohe, and the whole Windward side.",
    neighborhoods: ["Kailua", "Lanikai", "Enchanted Lake", "Maunawili", "Kaneohe", "Ahuimanu", "Kahaluu", "Waimanalo", "Kaneohe Bay", "Heeia"],
    localNeeds: [
      { title: "High Windward home values", text: "Size your term policy to the mortgage so your family can stay in the home they love." },
      { title: "Marine Corps Base Hawaii families", text: "MCBH Kaneohe Bay households often add private coverage on top of SGLI." },
      { title: "Small business owners", text: "Protect your shop, rental, or partnership with key person or buy-sell coverage." }
    ],
    faqs: [
      {
        question: "Is there a life insurance agent near me in Kailua or Kaneohe?",
        answer: "Yes. Kenneth Carson is a Hawaii-licensed Comparion Insurance agent serving Kailua, Lanikai, Kaneohe, Ahuimanu, Kahaluu, and Waimanalo through phone and video consultations. He has a 5.0-star rating from 74 reviews. Call (916) 505-1000."
      },
      {
        question: "How much life insurance do Windward Oahu homeowners need?",
        answer: "A good starting point is your full mortgage balance plus 10 times your income and future education costs. Because Kailua and Kaneohe home values are among the highest on Oahu, many families need more coverage than they expect."
      },
      {
        question: "Does Kenneth work with Marine Corps Base Hawaii families?",
        answer: "Yes. Kenneth helps Marines, sailors, and spouses at MCBH Kaneohe Bay compare private term life insurance that supplements SGLI and continues after military service."
      },
      {
        question: "Can I apply for life insurance without leaving the Windward side?",
        answer: "Absolutely. Quotes, applications, and policy reviews are handled by phone, video, and e-signature — no trip over the Pali or H-3 required."
      }
    ]
  },
  {
    slug: "lihue",
    name: "Lihue",
    area: "Kauai",
    zip: "96766",
    geo: { latitude: 21.9811, longitude: -159.3711 },
    image: "https://images.pexels.com/photos/11022065/pexels-photo-11022065.jpeg?auto=compress&cs=tinysrgb&w=1600",
    metaTitle: "Life Insurance Agent Near Me Lihue, Kauai, HI | Kenneth Carson",
    metaDescription: "Searching for a life insurance agent near me in Lihue or anywhere on Kauai? Kenneth Carson, licensed in HI, offers free life insurance quotes. 5.0★ (74 reviews).",
    headline: "Life Insurance Agent Near Me in Lihue, Kauai",
    intro: "On Kauai, life moves at its own pace — but the cost of living doesn't. From Lihue and Kapaa to Poipu, Hanalei, and Waimea, Garden Isle families work hard to stay on-island. Life insurance is how you make sure they can. I'm Kenneth Carson, a Hawaii-licensed Comparion agent, and I serve Kauai families by phone and video so you never have to fly to Honolulu for good advice.",
    neighborhoods: ["Lihue", "Kapaa", "Wailua", "Hanamaulu", "Koloa", "Poipu", "Kalaheo", "Hanapepe", "Waimea", "Princeville", "Hanalei", "Kilauea"],
    localNeeds: [
      { title: "Staying on-island", text: "Income replacement means your family won't be forced to leave Kauai if the worst happens." },
      { title: "Tourism & resort workers", text: "Hotel and visitor-industry jobs may have limited group coverage — an individual policy fills the gap." },
      { title: "Family land & legacy", text: "Permanent life insurance can help heirs keep land that's been in the family for generations." }
    ],
    faqs: [
      {
        question: "Who is a life insurance agent near me in Lihue, Kauai?",
        answer: "Kenneth Carson is a Hawaii-licensed Comparion Insurance agent serving Lihue, Kapaa, Koloa, Poipu, Waimea, Princeville, and all of Kauai through phone and video consultations. He holds a 5.0-star rating from 74 reviews. Call (916) 505-1000."
      },
      {
        question: "Are there fewer life insurance options on Kauai?",
        answer: "No. As a Hawaii-licensed agent, Kenneth can offer Kauai residents the same life insurance options available anywhere in the state, with the same rates."
      },
      {
        question: "What life insurance is best for a Kauai family?",
        answer: "Most families start with affordable term coverage to protect the mortgage and income. Families with land or a small business often add whole life to help pass assets to the next generation."
      },
      {
        question: "Can I get a life insurance quote on Kauai without meeting in person?",
        answer: "Yes. Kenneth handles quotes, applications, and policy reviews by phone, video, and e-signature, from Lihue to Hanalei."
      }
    ]
  }
];

export const hawaiiRegion = {
  key: "hawaii",
  stateName: "Hawaii",
  abbr: "HI",
  basePath: "/hawaii",
  hubImage: "https://images.unsplash.com/photo-1598135753163-6167c1a1ad65?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=1600",
  hubImageAlt: "Hawaiian island coastline",
  hubBadge: "Oahu · Big Island · Maui · Kauai",
  hubMetaTitle: "Life Insurance Agent Near Me Hawaii | Honolulu, Hilo, Kona, Maui, Kauai",
  hubMetaDescription: "Hawaii-licensed life insurance agent Kenneth Carson serves Honolulu, Pearl City, Kailua, Kapolei, Hilo, Kona, Maui & Lihue. Free quotes. 5.0★ from 74 reviews.",
  hubIntro: "Hawaii-licensed Comparion agent Kenneth Carson helps island families protect their ohana with honest, no-pressure life insurance advice — by phone or video, on every island.",
  hoursLabel: "Hawaii-friendly hours",
  hoursNote: HAWAII_HOURS_NOTE,
  relatedPosts: hawaiiRelatedPosts,
  hubFaqs: hawaiiHubFAQs,
  cities: hawaiiCities
};
